export default __webpack_public_path__ + "static/media/clairefontaine.55d9598b.jpg";